module.exports = __webpack_public_path__ + "img/mb-who-are-we-pic3.8a5efc4f.png";